
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import TableContainer from "components/Common/DataTableContainer";



const TeamPerformanceTable = ({ List, loading }) => {
  const dispatch = useDispatch();
  const permissions = JSON.parse(localStorage?.getItem('permissions')) || [];

  const columns = useMemo(
    () => [
      {
        header: 'Team Name',
        accessorKey: 'teamName',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Average Rating',
        accessorKey: 'Rating',
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => {
          return (
            <span>{row.original?.Rating}⭐</span>
          )
        }
      },
    ],
    []
  );

  // Meta title
  document.title = "Team Performance";

  return (
    <>
      <div className="container-fluid">
        <TableContainer
          loading={loading}
          columns={columns}
          data={List || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search..."
          pagination="pagination"
          docName="Team Performance"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default TeamPerformanceTable;
